import React, { useState } from 'react'
import ENUS from './Politica/ENUS'
import PTBR from './Politica/PTBR'
import { Col, Container, Row } from 'react-bootstrap'
import LogoQualy from '../Components/LogoQualy'

function PoliticaPrivacidade() {

    const [curLang, setCurLang] = useState('ptbr');

    return (
        <>
            <Container>
                <Row className='d-flex justify-content-center py-5'>
                    <Col xs={4}>
                        <LogoQualy className='d-flex justify-content-center' />
                    </Col>
                </Row>
                <Row>
                    <div className="d-flex justify-content-center">
                        <button
                            className="m-3 border border-0 bg-white"
                            onClick={() => {
                                setCurLang("ptbr");
                            }}
                        >
                            <img src="/static/images/br.svg" width={"50px"} />
                        </button>
                        <button
                            className="m-3 border border-0 bg-white"
                            onClick={() => {
                                setCurLang("enus");
                            }}
                        >
                            <img src="/static/images/us.svg" width={"50px"} />
                        </button>
                    </div>
                </Row>
                {curLang == 'ptbr' &&
                    <PTBR />
                }
                {curLang == 'enus' &&
                    <ENUS />
                }
            </Container>


        </>
    )
}

export default PoliticaPrivacidade